import React, { useMemo } from 'react';

import { getIn } from 'formik';
import { FormikValues } from 'formik/dist/types';

import {
  getFormikValue,
  onChangeWithInitReturn,
} from '../../../../utils/forms/formikFunctions';
import AppStandardTextField, {
  IAppStandardTextFieldProps,
} from '../../textfields/app-standart-text-field/AppStandardTextField';

interface IAppFormStandardTextFieldProps extends IAppStandardTextFieldProps {
  selectOnClick?: boolean;
  slotProps?: any;
  id?: string;
  name: string;
  formik?: FormikValues;
  onChange?: (e: any) => void;
}

const AppFormStandardTextField = (props: IAppFormStandardTextFieldProps) => {
  const { placeholder, label, id, name, formik, onChange, ...otherProps } =
    props;
  const value = useMemo(
    () => getFormikValue(getIn(formik?.values, name)),
    [formik?.values, name],
  );

  return (
    <AppStandardTextField
      {...props}
      id={id || name}
      value={value}
      name={name}
      onChange={onChangeWithInitReturn(
        name,
        formik,
        props.type === 'number',
        onChange,
      )}
      onBlur={formik?.handleBlur}
      error={getIn(formik?.touched, name) && !!getIn(formik?.errors, name)}
      helperText={getIn(formik?.touched, name) && getIn(formik?.errors, name)}
      type="number"
      label={null}
      placeholder={placeholder || (label as string)}
      {...otherProps}
    />
  );
};

export default AppFormStandardTextField;
